/* ============================================================
   PFEIL ZUM AUSBLENDEN DER VORTEILSZEILEN (Warenkorb-Schublade)
   Angelegt 18.08.2026. Von Stefan gewuenscht: "koennen wir hier
   ein kleinen Pfeil machen zum ausblenden der unteren sektion?"

   Die drei Haekchen-Zeilen im Fuss der Schublade (Freigabezeichnung,
   DIN EN 1090, Abholung) sind zusammen 69 px hoch. Der Knopf klappt
   sie weg; Zwischensumme, Steuerhinweis und Kaufknopf bleiben.

   Eigene Datei statt eines Blocks in `custom.js` — die ist an vollen
   Arbeitstagen von mehreren Sitzungen umkaempft, eine neue Datei
   kollidiert mit niemandem. Dasselbe Muster wie `mo-bildlupe`.
   Optik und Klappzustand stehen in `mo-warenkorb-kompakt.css`.

   ⚠️ DIE SCHUBLADE WIRD NEU GERENDERT. Bei jeder Mengenaenderung
   und jedem Hinzufuegen ersetzt Shopify den Inhalt ueber die
   Section-Rendering-API — ein einmal eingehaengter Knopf waere danach
   weg. Deshalb der MutationObserver, der DAUERHAFT laeuft und nicht
   abgemeldet wird.

   ⚠️ Keine Endlosschleife: Der Observer hoert nur auf `childList`.
   `aufbauen()` bricht ab, sobald der Knopf schon dasteht, und
   `anwenden()` aendert nur Klassen und Attribute — das loest keinen
   weiteren Durchlauf aus.

   Standard ist AUFGEKLAPPT. Die Zeilen sind Verkaufsargumente; sie
   verschwinden nur, wenn der Kunde es selbst so will. Der Zustand
   wird gemerkt, damit er die Schublade nicht bei jedem Oeffnen
   erneut zuklappen muss.

   RUECKBAU: diese Datei loeschen, die Zeile in
   `sections/cart-drawer.liquid` entfernen und den Block (b) am Ende
   von `mo-warenkorb-kompakt.css` streichen.
   ============================================================ */

(function () {
  'use strict';

  var SCHLUESSEL = 'mo-korb-vorteile'; /* 'zu' oder 'auf' */

  function istZu() {
    try {
      return localStorage.getItem(SCHLUESSEL) === 'zu';
    } catch (e) {
      return false; /* privater Modus: dann eben immer offen */
    }
  }

  function merken(zu) {
    try {
      localStorage.setItem(SCHLUESSEL, zu ? 'zu' : 'auf');
    } catch (e) {}
  }

  function anwenden(fuss, zu) {
    fuss.classList.toggle('mo-vorteile-zu', zu);
    var knopf = fuss.querySelector('.mo-vorteile-schalter');
    if (!knopf) return;
    knopf.setAttribute('aria-expanded', zu ? 'false' : 'true');
    knopf.setAttribute('aria-label', zu ? 'Vorteile einblenden' : 'Vorteile ausblenden');
    knopf.setAttribute('title', zu ? 'Vorteile einblenden' : 'Vorteile ausblenden');
  }

  function aufbauen() {
    var fuss = document.querySelector('#CartDrawer .cart-drawer__footer');
    if (!fuss) return;
    /* Ohne Haekchen-Zeilen gibt es nichts zu klappen — dann auch
       keinen Knopf. Betrifft den leeren Warenkorb. */
    if (!fuss.querySelector('.bullet_text')) return;

    var vorhanden = fuss.querySelector('.mo-vorteile-schalter');
    if (vorhanden) {
      anwenden(fuss, istZu());
      return;
    }

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'mo-vorteile-schalter';
    knopf.addEventListener('click', function () {
      var zu = !fuss.classList.contains('mo-vorteile-zu');
      anwenden(fuss, zu);
      merken(zu);
    });

    fuss.insertBefore(knopf, fuss.firstChild);
    anwenden(fuss, istZu());
  }

  aufbauen();
  document.addEventListener('DOMContentLoaded', aufbauen);

  var beobachter = new MutationObserver(aufbauen);
  beobachter.observe(document.querySelector('cart-drawer') || document.body, {
    childList: true,
    subtree: true
  });
})();
